// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer_AJ9HY","credits":"Footer_credits_HfoAk","socials":"Footer_socials_aAtsI"};